
import { LoginCallback, SecureRoute } from 'components/okta';
import { LoadingPopup } from 'components/pop-up';
import { AppSettingContext, NavigationEntryContext, TiHiRolloutProvider, TripContext } from 'contexts';
import { LogoutPage } from 'pages';
import React, { FC, useContext } from "react";
import { Route, Routes } from 'react-router-dom';
import { LOGIN_CALLBACK_URI } from 'utils';
import Content from '../../Content';

export const AppRoutes: FC = () => {

    const tripContext = useContext(TripContext)
    const settingsContext = useContext(AppSettingContext)
    const navContext = useContext(NavigationEntryContext)

    const isAppReady = tripContext.isReady() && settingsContext.isReady() && navContext.isReady()

    return (
        <>
            <Routes>
                <Route path="/logout" element={<LogoutPage />}/>
                <Route path={`${LOGIN_CALLBACK_URI}`} element={<LoginCallback/>}/>
                <Route path="*" element={<SecureRoute path="*" element={<TiHiRolloutProvider><Content/></TiHiRolloutProvider>} />}/>
            </Routes>
            <LoadingPopup visible={!isAppReady}/>
        </>
    )
}
